module.exports = __webpack_public_path__ + "img/NFC-ideas-preferences.e9c9102a.jpg";